<section class="home-hero mt-ncs">
  <picture class="home-hero__bg" aria-hidden="true">
    <source type="image/svg+xml" srcset="assets/dspace/images/wua-banner-emerald-v2.svg">
    <img src="assets/dspace/images/wua-banner-emerald-v2.svg" alt="">
  </picture>

  <div class="home-hero__overlay"></div>

  <div class="container home-hero__content">
    <div class="home-hero__panel">
      <p class="home-hero__eyebrow">WUA Institutional Repository</p>
      <h1 class="home-hero__title">WUASPACE</h1>
      <p class="home-hero__lead">
        WUASpace is an open access digital archive that collects, preserves, and shares scholarly work
        produced by the WUA community.
      </p>
      <p class="home-hero__text">
        Explore journal articles, book chapters, theses and dissertations, conference papers, pre-prints,
        working papers, technical and project reports.
      </p>

      <div class="home-hero__highlights">
        <span class="highlight-pill">Open Access</span>
        <span class="highlight-pill">Research Preservation</span>
        <span class="highlight-pill">Global Visibility</span>
      </div>
    </div>
  </div>
</section>
